<template>
    <section class="section-wrapp">
        <!--<StationMainInfo></StationMainInfo>-->
        <RestrictionsTable></RestrictionsTable>
    </section>
</template>

<script>
import RestrictionsTable from '@/components/stations/RestrictionsTable.vue'

export default {
  name: 'Restrictions',
  components: {
    RestrictionsTable
  },
  data () {
    return {
      message: ''
    }
  },
  computed: {
    isLoading () {
      return this.$store.getters[ 'station/isLoading' ]
    },
    hasError () {
      return this.$store.getters[ 'station/hasError' ]
    },
    error () {
      return this.$store.getters[ 'station/error' ]
    },
    hasStations () {
      return this.$store.getters[ 'station/hasPosts' ]
    },
    stations () {
      return this.$store.getters[ 'station/stations' ]
    }
  },
  created () {
    //    this.$store.dispatch('station/findAll')
    this.$store.dispatch('station/unsetCurrent')
  },
  methods: {
    async createStation () {
      const result = await this.$store.dispatch('station/create', this.$data.message)
      if (result !== null) {
        this.$data.message = ''
      }
    },
    showStations () {
      console.log(this.stations())
    }
  }
}
</script>
